// src/services/tokenService.js
import axios from 'axios';

/**
 * Inicializa el gestor de tokens
 */
export const initTokenManager = () => {
    // Limpiar interceptores previos para evitar duplicados
    if (responseInterceptorId !== null) {
        axios.interceptors.response.eject(responseInterceptorId);
    }
    
    // Configurar interceptor para renovar tokens
    setupTokenRenewal();
};

// Variable para almacenar el ID del interceptor
let responseInterceptorId = null;

/**
 * Configura el interceptor para detectar y manejar nuevos tokens
 */
const setupTokenRenewal = () => {
    // Interceptar todas las respuestas axios y almacenar el ID
    responseInterceptorId = axios.interceptors.response.use(
        (response) => {
            // Verificar si hay un nuevo token en la respuesta
            const newToken = response.headers['x-new-token'];
            
            if (newToken) {
                // Guardar el nuevo token
                localStorage.setItem('token', newToken);
                
                // Actualizar el token en las cabeceras por defecto
                axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                
                console.log('Token renovado automáticamente');
            }
            return response;
        },
        (error) => {
            // Verificar si hay un error de sesión
            if (error.response && error.response.status === 401) {
                const data = error.response.data;
                if (data.code === 'TOKEN_EXPIRED') {
                    // Cerrar sesión solo por token expirado
                    logout(data.message || 'Tu sesión ha expirado. Por favor vuelve a iniciar sesión.');
                }
            }
            return Promise.reject(error);
        }
    );
};



/**
 * Cierra la sesión del usuario
 * @param {string} message - Mensaje a mostrar al usuario
 */
export const logout = (message) => {
    // Limpiar interceptor de respuesta
    if (responseInterceptorId !== null) {
        axios.interceptors.response.eject(responseInterceptorId);
        responseInterceptorId = null;
    }
    
    // Eliminar token y datos de sesión
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('passwordIsCedula');
    
    // Eliminar cabeceras de autorización
    delete axios.defaults.headers.common['Authorization'];
    
    // Redirigir a la página de login
    window.location.href = '/login';
};

/**
 * Verifica si hay un token válido
 * @returns {boolean} - True si hay un token, false en caso contrario
 */
export const isAuthenticated = () => {
    return !!localStorage.getItem('token');
};

/**
 * Obtiene el token actual
 * @returns {string|null} - El token o null si no hay token
 */
export const getToken = () => {
    return localStorage.getItem('token');
};

/**
 * Obtiene el usuario actual
 * @returns {Object|null} - El usuario o null si no hay usuario
 */
export const getUser = () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
};